import { Pipe, PipeTransform } from '@angular/core';
import { DateUtility } from '@jms/model';
import { DateTime } from 'luxon';

@Pipe({
  name: 'toSimpleTime',
  standalone: true
})
export class ToSimpleTimePipe implements PipeTransform {

  transform(value: DateTime, timezone: string): string {
    timezone = !timezone || timezone === '' ? 'utc' : timezone;
    return DateUtility.getSimpleTime(value, timezone);
  }

}
